import styled from 'styled-components';

export const SelectionOptionsHeader = styled.div`
  display: flex;
  cursor: pointer;
  justify-content: space-between;
  align-items: center;
  padding: 0.5rem 0.5rem;
  border-bottom: solid 1px ${Styles.color.grey.four};
`;
